import { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { useMediaQuery } from 'react-responsive';
import { mediaQueryConstants } from '../constants';
import {
  Modal,
  Button,
  NavDropdown,
  Dropdown,
  CloseButton,
  Image
} from 'react-bootstrap';
import DropdownIcon from '../images/icons/dropdown-arrow.svg'
import { TimeTrackIcon } from './icons/TimeTrackIcon';
import { EyeIcon } from './icons/EyeIcon';
import { CheckIcon } from './icons/CheckIcon';

function StageLabel(props) {
  const {
          name,
          can_access_edit_title,
          stages,
          stageParentRef,
          scrollable,
          alignment,
          className,
          asDropdown,
          selected_stage_id,
          containerClassName='',
          hoverable
        } = props;
  const selectRef = useRef();
  const dropdownRef = useRef();
  const [dropdownStyle, setDropdownStyle] = useState({ bottom: 0, width: 0 });
  let parent_bounds = stageParentRef?.current?.getBoundingClientRect();
  const isLargeScreen = useMediaQuery({ query: `(max-width: ${mediaQueryConstants.LARGE}px)` })
  const [showMobilePopup, setShowMobilePopup] = useState(false);

  const handleSelect = (e, stageId) => {
    props.handleInlineEdit(function() {}, { stage_id: stageId })
  }

  const handleSelectMobile = (stageId) => {
    setShowMobilePopup(false)
    props.handleInlineEdit(function() {}, { stage_id: stageId })
  }

  const textAlignment = () =>{
    if(alignment === undefined) return 'text-center';

    return "text-"+alignment;
  }

  useEffect(() => {
    if (parent_bounds){
      setDropdownStyle({width: parent_bounds?.width, bottom: parent_bounds?.bottom + 20 })
    }
  }, [stageParentRef?.current, parent_bounds?.bottom, parent_bounds?.width, scrollable]);

  const openMobilePopup = (show) => {
    setShowMobilePopup(show);
  }

  const handleCloseMobilePopup = () => {
    setShowMobilePopup(false)
  }

  const getStyle = () => {
    if(isLargeScreen) return { display: 'none' };

    if (scrollable) {
      return {
        width: `${dropdownStyle.width}px`,
        maxHeight: `calc(100vh - 160px)`,
        maxHeight: `calc(100dvh - 160px)`,
        overflowY: 'auto'
      }
    } else {
      return {
        width: `${parent_bounds?.width}px`
      }
    }
  }

  const defaultRender = () =>{
    return can_access_edit_title ?
          <>
            <Dropdown
              className={`content__stage-dropdown dropdown--with-check ${className}`}
              ref={dropdownRef}
              onToggle={openMobilePopup}
            >
              <Dropdown.Toggle
                variant=""
                className={`${textAlignment()} text-truncate w-100 btn-sm`}
              >
                {name}
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={getStyle()}
                className="stage-list__dropdown w-100 box-shadow vertical-scroll_thin"
              >
                { stages && stages.map((opt, index) => (
                    <Dropdown.Item 
                      key={opt.id} 
                      onClick={(e) => handleSelect(e, opt.id) } 
                      className={` ${opt.id === selected_stage_id ? 'selected' : '' } d-flex justify-content-between`}
                    >
                      <span className={'text-truncate'}>{ opt.name }</span>
                      
                      <span className="d-flex align-items-center dropdown__selected--with-check">
                        {
                          opt?.enable_timestamp && 
                          <TimeTrackIcon color="#727580" className={opt.id === selected_stage_id  ? "me-3" : '' } height={12} width={10}/>
                        } 

                        {
                          opt?.visible_to_client &&
                          <EyeIcon className={'ms-2'}/>
                        }
                          
                        { opt?.require_approval_from_client &&
                          <CheckIcon className={'ms-2'}/>
                        }

                      </span>
                    
                    </Dropdown.Item>
                  ))
                }
              </Dropdown.Menu>
            </Dropdown>

            <Modal
              show={showMobilePopup && isLargeScreen}
              onHide={handleCloseMobilePopup}
              keyboard={true}
              centered
              className="stage-list__modal"
            >
              <Modal.Header closeButton>
                <Modal.Title
                  className="font-weight-bold stage-list__modal__title"
                >
                  Stage
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>

                <ul className="stage-list__modal__list vertical-scroll_thin mb-2 modal-list">
                  { stages && stages.map((opt, index) => (
                      <li
                        key={'stage_label'+opt.id}
                        onClick={(e) => handleSelectMobile(opt.id) }
                        className={'d-flex cursor-pointer justify-content-between text-truncate'}
                      >
                        { opt.name }

                        { opt.id === selected_stage_id &&
                          <span className="dropdown__selected--with-check">
                            <CheckIcon className={'me-2'}/>
                          </span>
                        }
                      </li>
                    ))
                  }
                </ul>
              </Modal.Body>
            </Modal>
          </>
        :
          <div className="content-group__readonly-stage d-flex align-items-center">
            <span className="text-truncate w-100">{name}</span>
          </div>
  }

  return (
    <>
      {asDropdown ? (
        <div 
          className={`
            detail 
            ${containerClassName} 
            ${hoverable ? 'hoverable' : ''} 
            ${showMobilePopup && 'active'}
            ${can_access_edit_title ? '' : 'bg-transparent'}
          `} 
          ref={stageParentRef}
        >
          {defaultRender()}
          {can_access_edit_title && (
            <Image 
              src={DropdownIcon} 
              height="8" 
              width="8" 
              className="dropdown-icon"
            />
          )}
        </div>
      ) : (
        defaultRender()
      )}
    </>
  );
}

export { StageLabel };
